var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nbgallery .item {\n  float: left;\n  padding: 10px 10px;\n  margin: 10px 10px;\n  position: relative;\n  text-align: center;\n  height: 138px; }\n\n.nbgallery .item img {\n  max-width: 100%;\n  max-height: 100%; }\n\n.nbgallery .item i.del {\n  color: #f00;\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: 20px;\n  cursor: pointer; }\n\n.nbgallery .photor {\n  background: url(" + escape(require("./camera_icon.png")) + ") no-repeat center; }\n  .nbgallery .photor input {\n    width: 128px;\n    height: 128px;\n    display: inline-block;\n    z-index: 200;\n    opacity: 0;\n    filter: alpha(opacity=0);\n    -ms-filter: 'alpha(opacity=0)'; }\n\n.nbgallery.disabled {\n  background-color: #e1e6ef; }\n\nspan img {\n  max-width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/nbinput/nbinput-image.component.scss
// module id = 165
// module chunks = 0 1